import { findIndex } from "lodash"

const templateState = {
  id: -1,
  type: "",
  concentration: 0,
  description: "",
  held: false,
  onShelf: true,
  containsTransferBuffer: false,
  lanes2: {
    lane1: {
      volume: 0,
      solutions: [{'DNA ladder (M)': 0.2}],
      solutionAlias: 'DNA ladder (M)',
      fragments: [],
      empty: true,
      particulate: 0
    },
    lane2: {
      volume: 0,
      solutions: [{'BB + RE': 0.2}],
      solutionAlias: 'BB + RE',
      fragments: [],
      empty: true,
      particulate: 0
    },
    lane3: {
      volume: 0,
      solutions: [{'Bb + RE': 0.2}],
      solutionAlias: 'Bb + RE',
      fragments: [],
      empty: true,
      particulate: 0
    },
    lane4: {
      volume: 0,
      solutions: [{'bb + RE': 0.2}],
      solutionAlias: 'bb + RE',
      fragments: [],
      empty: true,
      particulate: 0
    },
    lane5: {
      volume: 0,
      solutions: [{'S + RE': 0.2}],
      solutionAlias: 'S + RE',
      fragments: [],
      empty: true,
      particulate: 0
    },

    // lane6: {
    //   volume: 0,
    //   solutions: [],
    //   solutionAlias: '',
    //   fragments: [],
    //   empty: true,
    //   particulate: 0
    // }
  },
  lanes: {
    lane1: {
      volume: 0,
      solutions: [],
      solutionAlias: '',
      fragments: [],
      empty: true,
      particulate: 0
    },
    lane2: {
      volume: 0,
      solutions: [],
      solutionAlias: '',
      fragments: [],
      empty: true,
      particulate: 0
    },
    lane3: {
      volume: 0,
      solutions: [],
      solutionAlias: '',
      fragments: [],
      empty: true,
      particulate: 0
    },
    lane4: {
      volume: 0,
      solutions: [],
      solutionAlias: '',
      fragments: [],
      empty: true,
      particulate: 0
    },
    lane5: {
      volume: 0,
      solutions: [],
      solutionAlias: '',
      fragments: [],
      empty: true,
      particulate: 0
    },
    // lane6: {
    //   volume: 0,
    //   solutions: [],
    //   solutionAlias: '',
    //   fragments: [],
    //   empty: true,
    //   particulate: 0
    // }
  },
  laneImgConfig: "GelBufferEmpty",
  inScene: true,
  activeLane: 0
};

export default (state = templateState, action) => {
  let currentAgaroseGel;
  let currentAgaroseGels;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_AGAROSE_GEL" && !action.type.includes("@redux")) {
      if(action.payload.hasOwnProperty("id")){
          if(state.protocolSection.scene.apparatus.hasOwnProperty("agaroseGel")){
            currentAgaroseGel = state.protocolSection.scene.apparatus.agaroseGel[findIndex(state.protocolSection.scene.apparatus.agaroseGel, { id: action.payload.id })]
          }
      }
  }

  switch (action.type) {
    case 'CREATE_AGAROSE_GEL':

      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props }

      if(protocolSection.scene.apparatus.hasOwnProperty("agaroseGel")){
        protocolSection.scene.apparatus.agaroseGel = [ ...protocolSection.scene.apparatus.agaroseGel, newObj ]
      } else {
        protocolSection.scene.apparatus.agaroseGel = [newObj]
      }

      return { ...state, ...{
        protocolSection: protocolSection
      } }

      case "MAKE_GEL_IMG_CONFIG":
        //Payload = {id}

        let gels = protocolSection.scene.apparatus.agaroseGel
        let l1 = gels[findIndex(gels, { id: action.payload.id })].lanes.lane1.empty;
        let l2 = gels[findIndex(gels, { id: action.payload.id })].lanes.lane2.empty;
        let l3 = gels[findIndex(gels, { id: action.payload.id })].lanes.lane3.empty;
        let l4 = gels[findIndex(gels, { id: action.payload.id })].lanes.lane4.empty;
        //let l5 = gels[findIndex(gels, { id: action.payload.id })].lanes.lane5.empty;
        let gelConfigStr = "";

        if (l1 && l2 && l3 && l4) { // && l5) {
          gelConfigStr = "Empty";
        } else {
          gelConfigStr +=
            (!l1 ? "1" : "") +
            (!l2 ? "2" : "") +
            (!l3 ? "3" : "") +
            (!l4 ? "4" : "")// +
            //(!l5 ? "5" : "");
        }

        currentAgaroseGel.laneImgConfig = "GelBuffer" + gelConfigStr;
        protocolSection.scene.apparatus.agaroseGel[findIndex(state.protocolSection.scene.apparatus.agaroseGel, { id: action.payload.id })] = currentAgaroseGel;
        return { ...state, ...{ protocolSection: protocolSection } };

      case "SET_GEL_IN_SCENE":
        //Payload = {inScene}
        currentAgaroseGel.inScene = action.payload.inScene;
        protocolSection.scene.apparatus.agaroseGel[findIndex(state.protocolSection.scene.apparatus.agaroseGel, { id: action.payload.id })] = currentAgaroseGel;
        return { ...state, ...{ protocolSection: protocolSection } };

      case "SET_GEL_ON_SHELF":
        //Payload = {onShelf}
        currentAgaroseGel.onShelf = action.payload.onShelf;
        protocolSection.scene.apparatus.agaroseGel[findIndex(state.protocolSection.scene.apparatus.agaroseGel, { id: action.payload.id })] = currentAgaroseGel;
        return { ...state, ...{ protocolSection: protocolSection } };

      case "SET_GEL":
        //Payload = {id, type, concentration, description}
        return { ...state, ...action.payload };

      case "SET_GEL_LANE":
        //Payload = {id, laneNumber, laneData}
        currentAgaroseGel.lanes["lane" + action.payload.laneNumber] =
          action.payload.laneData;

        protocolSection.scene.apparatus.agaroseGel[findIndex(state.protocolSection.scene.apparatus.agaroseGel, { id: action.payload.id })] = currentAgaroseGel;

        return { ...state, ...{ protocolSection: protocolSection } };

      case "SET_GEL_HELD":
        currentAgaroseGel.held = action.payload.held;
        protocolSection.scene.apparatus.agaroseGel[findIndex(state.protocolSection.scene.apparatus.agaroseGel, { id: action.payload.id })] = currentAgaroseGel;
        return { ...state, ...{ protocolSection: protocolSection } };

      case "SET_GEL_ACTIVE_LANE":
        currentAgaroseGel.activeLane = parseInt(action.payload.activeLane);
        protocolSection.scene.apparatus.agaroseGel[findIndex(state.protocolSection.scene.apparatus.agaroseGel, { id: action.payload.id })] = currentAgaroseGel;
        return { ...state, ...{ protocolSection: protocolSection } };

      case "SET_GEL_CONTROLS_VISIBLE":
        // Hide the controls for all the other pipettes
        // state.gels.forEach(gel => {
        //   gel.controlsVisible = false;
        // });
        // Make the current gels controls visible
        currentAgaroseGels = state.protocolSection.scene.apparatus.agaroseGel;
        currentAgaroseGels.forEach(gel => {
          gel.controlsVisible = false;
        });
        protocolSection.scene.apparatus.agaroseGel = currentAgaroseGels

        currentAgaroseGel.controlsVisible = action.payload.controlsVisible;

        protocolSection.scene.apparatus.agaroseGel[findIndex(state.gels, { id: action.payload.id })] = currentAgaroseGel;
        return { ...state, ...{ protocolSection: protocolSection } };

      case "HIDE_ALL_CONTROLS":
        // Hide the controls for all the other pipettes
        currentAgaroseGels = state.protocolSection.scene.apparatus.agaroseGel;
        currentAgaroseGels.forEach(gel => {
          gel.controlsVisible = false;
        });
        protocolSection.scene.apparatus.agaroseGel = currentAgaroseGels

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case "UNDO":
        //Payload = {lastState}
        if (action.payload.lastState !== null) {

          protocolSection.scene.apparatus.agaroseGel = action.payload.lastState.scene.apparatus.agaroseGel

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        } else {
          return state;
        }

      default:
        return state;
    }
  };
